// Coffees page: one scrollable row per series; tabs show one series as a grid.
// Without JavaScript every row still scrolls and every coffee shows.
const root = document.querySelector('[data-ogni-collection]');
if (root) {
  const tabs = root.querySelectorAll('[data-ogni-filter]');
  const rows = root.querySelectorAll('[data-ogni-row]');
  const green = root.querySelector('[data-ogni-green]');

  // Arrows (desktop): scroll by one visible page of cards.
  const setupRow = (row) => {
    const track = row.querySelector('[data-ogni-track]');
    const arrows = row.querySelector('[data-ogni-arrows]');
    const prev = row.querySelector('[data-ogni-prev]');
    const next = row.querySelector('[data-ogni-next]');
    if (!track || !arrows) return;
    const update = () => {
      const overflow = track.scrollWidth - track.clientWidth > 4 && !row.classList.contains('is-grid');
      arrows.hidden = !overflow;
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    };
    const page = (dir) => {
      const card = track.querySelector('.ogni-card');
      const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0) : track.clientWidth;
      const perPage = Math.max(1, Math.floor((track.clientWidth + 1) / step));
      track.scrollBy({ left: dir * step * perPage, behavior: 'smooth' });
    };
    prev.addEventListener('click', () => page(-1));
    next.addEventListener('click', () => page(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    row.ogniUpdate = update;
    update();
  };
  rows.forEach(setupRow);

  const apply = (value) => {
    tabs.forEach((tab) => tab.setAttribute('aria-pressed', String(tab.dataset.ogniFilter === value)));
    rows.forEach((row) => {
      const match = value === 'all' || row.dataset.ogniRow === value;
      row.hidden = !match;
      row.classList.toggle('is-grid', value !== 'all' && match);
      if (row.ogniUpdate) row.ogniUpdate();
    });
    if (green) green.hidden = value !== 'all';
    const url = new URL(window.location.href);
    if (value === 'all') url.searchParams.delete('series');
    else url.searchParams.set('series', value);
    window.history.replaceState({}, '', url);
  };
  tabs.forEach((tab) => tab.addEventListener('click', () => apply(tab.dataset.ogniFilter)));
  const initial = new URL(window.location.href).searchParams.get('series') || root.dataset.ogniDefault;
  if (initial) apply(initial);
}
